<script lang="tsx" setup>
import { computed } from "vue";

type Props = {
  tag?: string;
};
const props = defineProps<Props>();
const tag = computed(() => props.tag ?? "div");
</script>
<template>
  <component
    :is="tag"
    class="px-2.5 py-1 bg-primary-50 dark:bg-primary-900/30 text-primary-800 dark:text-primary-200 rounded-2xl text-xs font-medium border border-primary-200 dark:border-primary-800"
  >
    <slot />
  </component>
</template>
